// 2025/3/21
// shopは互換性のために残している。
// 現在使われているのは store + course

import z from "zod";
import type { Staff, Store } from "../../shared/web/schema/getStores";

const filterSchema = z.object({
  stores: z.array(
    z.object({
      courseIds: z.array(z.number()).optional(),
      id: z.number(),
      staffIds: z.array(z.number().nullable()).optional(),
    }),
  ),
  version: z.number(),
});

export function createViewParam(storeId: number, courseId: number, staffId: number | null) {
  return btoa(JSON.stringify(filterSchema.parse({ stores: [{ courseIds: [courseId], id: storeId, staffIds: [staffId] }], version: 2 })));
}

export default function storeFilter(stores: Store[] | null | undefined) {
  if (!stores) {
    return stores;
  }

  const searchParams = new URLSearchParams(window.location.search);
  const filterStr = searchParams.get("view");
  if (filterStr) {
    const filter = filterSchema.parse(JSON.parse(atob(decodeURIComponent(filterStr))));
    if (filter.version === 2) {
      return stores.flatMap((store) => {
        const filterStore = filter.stores.find((f) => f.id === store.id);
        if (filterStore) {
          const courses = store.courses.filter((c) => filterStore.courseIds?.includes(c.id) ?? true);
          // コースがない店舗は除外
          if (courses.length === 0) {
            return [];
          }
          const staffs: (Staff | null)[] = store.staffs.filter((s) => filterStore.staffIds?.includes(s.id) ?? true);
          if (filterStore.staffIds?.includes(null) ?? true) {
            staffs.unshift(null);
          }
          return { courses, staffs, store };
        }
        return [];
      });
    }
  }

  const shopParams = searchParams.get("shop")?.split(",") ?? [];
  const storeParams = searchParams.get("store")?.split(",") ?? [];
  const courseIds = searchParams.get("course")?.split(",") ?? [];
  const storeIds = new Set([...shopParams, ...storeParams]);

  return stores
    .flatMap((store) => {
      if (courseIds.length === 0 && storeIds.size === 0) {
        return { courses: store.courses, staffs: [null, ...store.staffs], store };
      }

      if (storeIds.has(store.id.toString())) {
        let courses = store.courses;
        if (0 < courseIds.length) {
          courses = courses.filter((c) => courseIds.includes(c.id.toString()));
        }

        return { courses, staffs: [null, ...store.staffs], store };
      }
      return [];
    })
    .filter((store) => 0 < store.courses.length); // コースがない店舗は除外
}
